export default __webpack_public_path__ + "static/media/menu-white.11837919.svg";